import PropTypes from 'prop-types';
import classNames from 'classnames';
import { trans, getResourcePath } from '@spotahome/soyuz/client';
import { Rating } from '@spotahome/ui-library';
import LazyLoad from '@spotahome/ui-library/src/tenant/components/LazyLoad';
import { formatRelativeDates } from '@spotahome/ui-library/src/tenant/components/utils/dateUtils';

import './Review.scss';

const TENANT_ICON = '/images/show-rentable-unit/icon_tenant.svg';
const LANDLORD_ICON = '/images/show-rentable-unit/icon_landlord.svg';

const Review = ({
  publicationDate,
  text = '',
  rating = null,
  author = '',
  isReply = false
}) => {
  const itemClassName = classNames('review-item', {
    'review-item--reply': isReply
  });

  const detailsClassName = classNames('review-details', {
    'review-details--reply': isReply
  });

  const iconUrl = isReply ? LANDLORD_ICON : TENANT_ICON;
  const reviewAuthor = author || trans('listing.reviews.reply.title');

  return (
    <div className={itemClassName}>
      <div className={detailsClassName}>
        <figure className="review-details__avatar">
          <LazyLoad offset={100} height={60} once>
            <img src={getResourcePath(iconUrl)} alt={reviewAuthor} />
          </LazyLoad>
        </figure>
        <div>
          <p className="review-details__author">{reviewAuthor}</p>
          <p className="review-details__date">
            {formatRelativeDates(publicationDate, new Date())}
          </p>
          {rating !== null && (
            <div className="review-details__rating">
              <Rating rating={rating} size="small" />
            </div>
          )}
        </div>
      </div>
      <p className="review-text">{text}</p>
    </div>
  );
};

Review.propTypes = {
  publicationDate: PropTypes.string.isRequired,
  author: PropTypes.string,
  rating: PropTypes.number,
  text: PropTypes.string,
  isReply: PropTypes.bool
};

export default Review;
